(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.directive('dropdownMenuHover', [dropdownMenuHoverFunction]);

    /* Metronic dropdown hover directive */
    function dropdownMenuHoverFunction() {
        var directive = {
            link: link
        };
        return directive;

        function link(scope, element) {
            element.dropdownHover(); 
        }
    }

})();